import { handleOnInitializeCalculation } from "@/api/calculations";
import { Can } from "@/components/citadel";
import { Insights } from "@/components/insights";
import { AddCalculationModal } from "@/modals/calculations/add-calculation-modal";
import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { icon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { Fragment } from "react";

export function CalculationsMenu() {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Functions */
	async function handleOnOpenFromSkretch() {
		handleOnInitializeCalculation({ type: "offer" });
	}

	/** Render */
	return (
		<Fragment>
			{/* Both insights endpoints gate on `read Calculation` — the feature answers questions
			    about the calculation tables — so the trigger goes with the rule. */}
			<Can
				action="read"
				subject="Calculation"
			>
				<Insights />
			</Can>
			<Menu
				items={() => [
					{
						label: t("calculations.from_file"),
						icon: icon("File"),
						onClick: disclosure.onOpen,
					},
					{
						label: t("calculations.from_scratch"),
						icon: icon("Sparkle"),
						onClick: handleOnOpenFromSkretch,
					},
				]}
			>
				<Button
					icon={<Icon name="Plus" />}
					variant="primary"
				>
					{t("calculations.add_calculation")}
				</Button>
			</Menu>
			{disclosure.isOpen && (
				<AddCalculationModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
				/>
			)}
		</Fragment>
	);
}
